import { F0Box, F0Text } from '@factorialco/f0-react'
import { Dropdown, Switch, type DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { Delete, Ellipsis, Pencil } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import type { MergedField } from './types'

type Props = {
  field: MergedField
  onToggleVisibility: (fieldKey: string, newVisible: boolean) => void
  onEdit: (field: MergedField) => void
  onDelete: (fieldKey: string) => void
}

function SectionField({ field, onToggleVisibility, onEdit, onDelete }: Props) {
  const fieldActions: DropdownItem[] = [
    {
      label: i18n.t('common.edit'),
      icon: Pencil,
      onClick: () => onEdit(field),
    },
    {
      label: i18n.t('common.delete'),
      icon: Delete,
      critical: true,
      onClick: () => onDelete(field.key),
    },
  ]

  return (
    <F0Box display="flex" alignItems="center" justifyContent="between" paddingX="md" paddingY="sm">
      <F0Text content={field.displayLabel} variant="body" />
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
        <Switch
          checked={field.visible}
          onCheckedChange={(checked) => onToggleVisibility(field.key, checked)}
          title={field.displayLabel}
          hideLabel
        />
        {!field.predefined && (
          <Dropdown
            items={fieldActions}
            icon={Ellipsis}
            size="sm"
            data-testid={`field-actions-${field.key}`}
          />
        )}
      </F0Box>
    </F0Box>
  )
}

export default SectionField
